import React, { Component } from "react";
import { Glyphicon } from "react-bootstrap";
import styles from "./AdminCompanyProjects.scss";
import { Link } from "react-router-dom";
import Table from "../../../../components/common/table/Table";
import arrowRightIcon from "../../../../assets/images/arrow-right.svg";
import AdminCompanyNav from "./AdminCompanyNav";
import _ from "lodash";

import { PROJECT_MATCHES_TABLE } from "../../../../actions/project.actions";

const STATUS_CANCELLED_ID = 11;

class AdminCompanyProjects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCancelledProjects: false
    };

    this.toogleCancelledProjects = this.toogleCancelledProjects.bind(this);
  }

  toogleCancelledProjects() {
    this.setState(prevState => {
      return {
        showCancelledProjects: !prevState.showCancelledProjects
      };
    });
  }

  getCurrentProjects() {
    if (!this.props.projects) return [];
    let projects;
    if (this.state.showCancelledProjects) {
      projects = this.props.projects;
    } else {
      projects = _.filter(
        this.props.projects,
        p => p.status_id !== STATUS_CANCELLED_ID
      );
    }

    return projects;
  }

  getProjectDisplayText(project) {
    return (
      <div className={styles.rowHeader}>
        <div>
          <Link to={`/admin/project/${project.id}/detail`}>
            {project.title}
          </Link>
        </div>
        <div className={styles.rowHeaderSubtitle}>{project.city}</div>
      </div>
    );
  }

  getFilterButtons() {
    const toogleCancelledComponent = this.state.showCancelledProjects ? (
      <span>
        {" "}
        <Glyphicon glyph="eye-close" /> &nbsp; Hide Cancelled{" "}
      </span>
    ) : (
      <span>
        {" "}
        <Glyphicon glyph="eye-open" /> &nbsp; Show Cancelled{" "}
      </span>
    );

    return (
      <div className={styles.filterButtons}>
        <span
          className={styles.filterButtonsItem}
          onClick={this.toogleCancelledProjects}
        >
          {toogleCancelledComponent}
        </span>
      </div>
    );
  }

  getActions(project) {
    return (
      <div className={styles.actionsContainer}>
        <Link to={`/admin/project/${project.id}/detail`}>
          <img src={arrowRightIcon} className={styles.arrowButton} />
        </Link>
      </div>
    );
  }

  render() {
    const projects = this.getCurrentProjects();
    const mappedProjects = projects.map(project => {
      return {
        rowKey: project.id,
        data: [
          {
            displayText: this.getProjectDisplayText(project),
            orderByText: project.title
          },
          {
            displayText: _.get(project, "status.display_name"),
            orderByText: _.get(project, "status.display_name")
          },
          {
            displayText: `${project.employer.first_name} ${
              project.employer.last_name
            }`,
            orderByText: `${project.employer.first_name} ${
              project.employer.last_name
            }`
          },
          {
            displayText: project.updated_at,
            orderByText: project.updated_at
          },
          {
            displayText: this.getActions(project)
          }
        ]
      };
    });

    const tableData = {
      headers: [
        {
          displayText: "Project Title & Location"
        },
        {
          displayText: "Status"
        },
        {
          displayText: "Hiring Manager"
        },
        {
          displayText: "Last Activity"
        },
        {
          align: "right",
          displayText: this.getFilterButtons(),
          sortDisabled: true
        }
      ],
      rows: mappedProjects
    };

    const defaultSort = {
      headerIndex: 1,
      order: "desc"
    };

    return (
      <div>
        <AdminCompanyNav
          id={this.props.id}
          projectsCount={this.props.projects && this.props.projects.length}
        />
        <div className={styles.matches}>
          <h2 className={styles.pageTitle}>All Projects</h2>
          <div className={styles.divider}>
            <div className={styles.top} />
            <div className={styles.bottom} />
          </div>

          <Table
            name={PROJECT_MATCHES_TABLE}
            colsConfig={["40%", "20%", "20%", "20%"]}
            defaultSort={defaultSort}
            tableData={tableData}
            showSubNavIfEmpty={true}
          />
        </div>
      </div>
    );
  }
}

export default AdminCompanyProjects;



// WEBPACK FOOTER //
// ./src/routes/admin/company/components/AdminCompanyProjects.js